import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  bannerTitle: {
    id: 'yield-management.schedule-detail.class-insights-callout-banner.banner-title',
    defaultMessage: 'Class Insights Dashboard',
  },
  bannerDescription: {
    id: 'yield-management.schedule-detail.class-insights-callout-banner.banner-description',
    defaultMessage: 'See what class types and times are performing best on the new <a>Class Insights dashboard</a>',
  },
  badgeText: {
    id: 'yield-management.schedule-detail.class-insights-callout-banner.badge-text',
    defaultMessage: 'NEW',
  },
});
